import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/Base/Popover";
import { Button } from "@/components/Base/Button";
import { Calendar } from "@/components/Base/Calendar";
import { ClassNameValue } from "tailwind-merge";
import { useEffect } from "react";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";

export const DatePicker = ({
  value,
  onChange,
  className,
  disabled,
  displayFormat = "PPP",
  showClear = false,
}: {
  value?: Date;
  onChange?: (value: Date | undefined) => void;
  className?: ClassNameValue;
  disabled?: boolean;
  displayFormat?: string;
  showClear?: boolean;
}) => {
  const [date, setDate] = React.useState<Date | undefined>(value);

  useEffect(() => {
    setDate(value);
  }, [value]);

  const handleDateSelect = (date: Date | undefined) => {
    if (onChange) {
      onChange(date);
    }
    setDate(date);
  };

  const handleClear = () => {
    if (onChange) {
      onChange(undefined);
    }
    setDate(undefined);
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "justify-start text-left font-normal",
            !date && "text-muted-foreground",
            className
          )}
          disabled={disabled}
        >
          {date ? null : <CalendarIcon className="mr-2" size={12} />}
          {date ? format(date, displayFormat) : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleDateSelect}
          autoFocus
        />
        {showClear && date && (
          <div className="border-t p-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handleClear}
              className="w-full"
            >
              <Icon name={IconNames.x} className="mr-2 h-4 w-4" />
              Clear
            </Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};
